import React, { 
  useEffect
} from "react";
import {
  AnimatePresence,
  motion
} from "framer-motion";
import { 
  ExternalLink,
  Github,
  X
} from "lucide-react"; 
import useStyles from "./stylesheet"; 

const ProjectModal = ({ visible, onClose, data }) => {
  const classes = useStyles();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    if (visible) {
      window.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden"; 
    } else {
      document.body.style.overflow = "auto"; 
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "auto"; 
    };
  }, [visible, onClose]);

  if (!data) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className={classes.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className={classes.modalContainer}
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className={classes.closeButton} onClick={onClose}>
              <X size={24} />
            </button>

            <div className={classes.layout}>
              <div className={classes.imageSection}>
                <img src={data.imageURL} alt={data.title} className={classes.image} />
                <div className={classes.typeBadge}>
                  {data.type.toUpperCase()}
                </div>
              </div>

              <div className={classes.contentSection}>
                <h2 className={classes.title}>{data.title}</h2>
                
                <div className={classes.descriptionArea}>
                  <p className={classes.description}>{data.description}</p>
                </div>

                <div className={classes.buttonContainer}>
                  <a
                    href={data.demoLink || "#!"}
                    target={data.demoLink ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    className={`${classes.button} ${classes.primaryButton} ${!data.demoLink ? classes.disabled : ""}`}
                    onClick={(e) => !data.demoLink && e.preventDefault()}
                  >
                    Live Demo <ExternalLink size={18} />
                  </a>

                  <a
                    href={data.sourceLink || "#!"}
                    target={data.sourceLink ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    className={`${classes.button} ${classes.secondaryButton} ${!data.sourceLink ? classes.disabled : ""}`}
                    onClick={(e) => !data.sourceLink && e.preventDefault()}
                  >
                    source <Github size={18} />
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}; 

export default ProjectModal;